/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";

/* Styles */
import styles from "./styles.js"

const Footer = props => {
  const { setShowModal } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col>
          <UCButton
            onClick={() => setShowModal(false)}
            type="primary"
            className={classes.cancelBtn}
            text={<FormattedMessage id="warningModal.button"/>}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default Footer;